import { useState, useEffect } from "react"

function UploadPage(){

const [file,setFile] = useState(null)
const [documents,setDocuments] = useState([])

useEffect(()=>{

fetch("https://final-trace.onrender.com/api/documents/all")
.then(res=>res.json())
.then(data=>{
setDocuments(data)
})

},[])

const handleUpload = async (e)=>{
e.preventDefault()

if(!file){
alert("Please select a file")
return
}

const formData = new FormData()
formData.append("file",file)

const res = await fetch("https://final-trace.onrender.com/api/documents/upload",{
method:"POST",
body:formData
})

const data = await res.json()

alert(data.message)

window.location.reload()

}

const deleteDoc = async(id)=>{

await fetch(`https://final-trace.onrender.com/api/documents/delete/${id}`,{
method:"DELETE"
})

alert("Document deleted")

window.location.reload()

}

return(

<div style={{
display:"flex",
justifyContent:"center",
alignItems:"flex-start",
minHeight:"100vh",
background:"linear-gradient(135deg,#1e3c72,#2a5298)",
paddingTop:"40px"
}}>

<div style={{
background:"white",
padding:"40px",
borderRadius:"12px",
width:"420px",
boxShadow:"0 8px 20px rgba(0,0,0,0.2)"
}}>

<h2 style={{textAlign:"center"}}>Upload Documents</h2>

<form onSubmit={handleUpload}>

<input
type="file"
onChange={(e)=>setFile(e.target.files[0])}
style={{
width:"100%",
marginTop:"20px"
}}
/>

<button
type="submit"
style={{
width:"100%",
padding:"12px",
marginTop:"20px",
background:"#2a5298",
color:"white",
border:"none",
borderRadius:"6px",
cursor:"pointer"
}}
>
Upload
</button>

</form>

<h3 style={{marginTop:"30px"}}>Uploaded Documents</h3>

{documents.map((doc)=>(

<div key={doc._id} style={{
border:"1px solid #e5e7eb",
padding:"12px",
marginTop:"12px",
borderRadius:"8px",
background:"#f8fafc",
boxShadow:"0 2px 8px rgba(0,0,0,0.1)"
}}>

<a
href={`https://final-trace.onrender.com/${doc.filePath}`}
target="_blank"
rel="noreferrer"
style={{
textDecoration:"none",
color:"#1e3c72",
fontWeight:"bold"
}}
>
{doc.fileName}
</a>

<br/><br/>

<button
onClick={()=>deleteDoc(doc._id)}
style={{
background:"#dc2626",
color:"white",
border:"none",
padding:"6px 12px",
borderRadius:"5px",
cursor:"pointer"
}}
>
Delete
</button>

</div>

))}

</div>

</div>

)

}

export default UploadPage